import {
  HttpErrorResponse,
  type HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ROUTE_DATA } from '../router/route-data';
import { DialogService } from '../typed-dialog';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const dialogService = inject(DialogService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403) {
        router.navigate([`/${ROUTE_DATA['access-restricted'].path}`], {
          replaceUrl: true,
        });
      } else if (error.status === 404) {
        router.navigate([`/${ROUTE_DATA['not-found'].path}`], {
          replaceUrl: true,
        });
      } else if (
        error.status === 0 ||
        (error.status >= 500 && error.status < 600)
      ) {
        router.navigate([`/${ROUTE_DATA['something-went-wrong'].path}`]);

        dialogService.closeAll();
      }

      return throwError(() => error);
    }),
  );
};
